import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';

@Component({
  selector: 'app-herramientas',
  templateUrl: './herramientas.component.html',
  styleUrls: ['./herramientas.component.scss']
})
export class HerramientasComponent implements OnInit {

  records: any = [];

  constructor(
    private rest: RestService
  ) { this.GetData(); }

  ngOnInit() {
    setInterval(function () { this.GetData(); }.bind(this), 60000);
  }

  GetData() {
    this.rest.GetEvents()
    .subscribe(
      (data) => {
        this.records = data['data'];
      });
  }

}
